module.exports = __webpack_public_path__ + "static/media/netsuite-upgrade.5b89d682.png";